import React from 'react';
import PropTypes from 'prop-types';

import SupportRequestPresenter from '../../../../../../presenters/SupportRequestPresenter';
import Group from '../../../../../../components/Group';
import FormHeader from '../../../../../../components/FormHeader';
import Row from '../../../../../../components/Row';
import Column from '../../../../../../components/Column';
import Value from '../../../../../../components/Value';
import Gallery from '../../../../../../components/Gallery';
import { emptyValueToDash } from '../../../../../../utils/values';
import editButton from '../../../../../../assets/edit-button.svg';
import Button from '../../../../../../components/Button';

const AdditionalInfo = (props) => {
  const { request, onEditModalOpen } = props;

  const plaidTicketUrl = SupportRequestPresenter.plaidTicketUrl(request);
  const reviewerComment = SupportRequestPresenter.reviewerComment(request);

  return (
    <div>
      <Group>
        <FormHeader
          title="Additional Info"
          titleClassName="title-medium additional-info-spacer"
          actionsClassName="additional-info-actions"
        >
          <Button
            className="action-button zoomed top"
            onClick={onEditModalOpen}
          >
            <img className="edit-icon" alt="edit-button" src={editButton} />
          </Button>
        </FormHeader>
        <Row>
          <Column>
            <Value attr="plaidTicketUrl" title="Plaid Ticket url">
              {emptyValueToDash(plaidTicketUrl)}
            </Value>
          </Column>
          <Column>
            <Value attr="comment" title="Comment">
              {emptyValueToDash(reviewerComment)}
            </Value>
          </Column>
        </Row>
        <Row>
          <Gallery images={request.receipts} title="Receipt/Screenshot" />
        </Row>
      </Group>
    </div>
  );
};

export default AdditionalInfo;

AdditionalInfo.propTypes = {
  request: SupportRequestPresenter.shape().isRequired,
  onEditModalOpen: PropTypes.func.isRequired,
};
